// extracted by mini-css-extract-plugin
export var barContainer = "_4u-0";
export var extraThin = "_4u-3";
export var fillBar = "_4u-6";
export var fillContainer = "_4u-4";
export var overflow = "_4u-8";
export var overflowContainer = "_4u-5";
export var regular = "_4u-7";
export var thick = "_4u-1";
export var thin = "_4u-2";